module.exports = __webpack_public_path__ + "static/media/file-searching.b0352df9.svg";